import { Routes, Route } from 'react-router-dom';
import PrivateRoute from '../../components/PrivateRoute';
import { Default } from './default';
import { SideBars } from '../../components/Sidebar/sidebars';
import { ProjectRoute, DetailsRoute, HookRoute, SettingRoute } from '..';
import Notifications from '../notifications';
import ProjectDetails from '../projectdetails';
import UserListSettings from '../userlistsettings';
import styles from './details.css';
import { connect } from 'react-redux';
import { WebSocketConnection } from '../../socket/socket';
import { useEffect } from 'react';
export function DashboardRoute({ token, alerts }) {
  useEffect(() => {
    WebSocketConnection({ token });
  }, []);
  return (
    <div>
      <SideBars style={{ minWidth: '50px' }} />
      <div className="routesmain">
        <Routes>
          <Route
            path=""
            element={
              <PrivateRoute>
                <Default />
              </PrivateRoute>
            }
          />
          <Route
            path="/project"
            element={
              <PrivateRoute>
                <ProjectRoute />
              </PrivateRoute>
            }
          />
          <Route
            path="/hook"
            element={
              <PrivateRoute>
                <HookRoute />
              </PrivateRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <PrivateRoute>
                <Notifications key={alerts} />
              </PrivateRoute>
            }
          />
          <Route
            path="/details/:id"
            element={
              <PrivateRoute>
                <DetailsRoute />
              </PrivateRoute>
            }
          />
          <Route
            path="/projectdetails/:id"
            element={
              <PrivateRoute>
                <ProjectDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/setting"
            element={
              <PrivateRoute>
                <SettingRoute />
              </PrivateRoute>
            }
          />
          <Route
            path="/userlistsettings"
            element={
              <PrivateRoute>
                <UserListSettings />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  isLoggedin: state.app.user.isLoggedin,
  projectList: state.app.projectList,
  token: state.app.user.token,
  serviceid: state.app.serviceid,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardRoute);
